import { render } from "./NotificationSchedule.vue?vue&type=template&id=5689bf6e&scoped=true&ts=true"
import script from "./NotificationSchedule.vue?vue&type=script&lang=ts"
export * from "./NotificationSchedule.vue?vue&type=script&lang=ts"

import "./NotificationSchedule.vue?vue&type=style&index=0&id=5689bf6e&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5689bf6e"]])

export default __exports__